import type { CaseStudyDetail, CaseStudyListQuery, StudentCaseStudyListQuery, CaseStudyListResult, CreateCaseStudyInput, SaveCaseStudyInput, PublishedCaseStudy, PublishedCaseStudyListResult, PublishedCaseQuestion } from "@pustak-lms/contracts";

export function caseStudyClient(request: <T>(path: string, init?: RequestInit) => Promise<T>) {
  const base = "/api/platform/qbank/case-studies";
  const path = (id: string) => `${base}/${encodeURIComponent(id)}`;
  const queryString = (query: CaseStudyListQuery) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) if (value !== undefined && value !== "") params.set(key, String(value));
    return params.size ? `?${params}` : "";
  };
  const learn = (preview: boolean) => `/api/learn/${preview ? "preview/" : ""}case-studies`;
  return {
    listCaseStudies: (query: CaseStudyListQuery = {}) => request<CaseStudyListResult>(`${base}${queryString(query)}`),
    getCaseStudy: (id: string) => request<CaseStudyDetail>(path(id)),
    createCaseStudy: (input: CreateCaseStudyInput) => request<CaseStudyDetail>(base, { method: "POST", body: JSON.stringify(input) }),
    saveCaseStudy: (id: string, input: SaveCaseStudyInput) => request<CaseStudyDetail>(path(id), { method: "POST", body: JSON.stringify(input) }),
    listPublishedCaseStudies: (query: StudentCaseStudyListQuery = {}, preview = false) => request<PublishedCaseStudyListResult>(`${learn(preview)}${queryString(query)}`),
    getPublishedCaseStudy: (id: string, preview = false) => request<PublishedCaseStudy>(`${learn(preview)}/${encodeURIComponent(id)}`),
    getPublishedCaseQuestion: (id: string, questionId: string, preview = false) => request<PublishedCaseQuestion>(`${learn(preview)}/${encodeURIComponent(id)}/questions/${encodeURIComponent(questionId)}`)
  };
}
